<template>
  <v-row>
    <v-col cols="4" class="grey--text body-2 text-right px-2 text_row_title">{{ title }}</v-col>
    <v-col cols="8" class="py-0 pl-1 pr-3 body-2">
      <v-progress-linear
        :value="calcValue"
        height="20"
        rounded
        :color="color"
      >
        <span v-if="text">{{ text }}</span>
        <slot v-else />
      </v-progress-linear>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "ProgressRow",
  props: {
    title: {
      type: String,
      default: null
    },
    text: {
      type: String,
      default: null
    },
    color: {
      type: String,
      default: null
    },
    value: {
      type: Number,
      mandatory: true
    },
    maxValue: {
      type: Number,
      default: 100
    }
  },

  computed: {
    calcValue() {
      return this.value / (this.maxValue / 100);
    }
  }
};
</script>

<style lang="sass" scoped>
.text_row_title
  padding-top: 3px
  padding-bottom: 0px

</style>